import { Tooltip } from "antd";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import Switch from "react-switch";
import { handleMode } from "../../../data/slices/layout";
import coins from "./../../../assets/img/coins.svg";
import compta from "./../../../assets/img/compta.svg";
import { useLocation, useNavigate, useParams } from "react-router-dom";

function SwitchMode() {
  const { mode } = useSelector((state) => state.layout);
  const dispatch = useDispatch();
  const location = useLocation();
  const pathname = location.pathname;
  const { id } = useParams();

  const navigate = useNavigate();
  const isCompta = mode === "compta";

  const handleModeChange = () => {
    const nextMode = isCompta ? "treso" : "compta";
    dispatch(handleMode(nextMode));

    // check if the pathname includes "compta-plan" and if the mode is "compta" and if so, navigate to the root of the project
    if (isCompta && pathname.includes("compta-plan")) {
      navigate(`/project/${id}/`);
    }
  };

  return (
    <Tooltip
      title="hello"
      trigger="hover"
      mouseLeaveDelay={0}
      mouseEnterDelay={0.8}
    >
      <Switch
        checked={isCompta}
        onChange={handleModeChange}
        without-border={isCompta ? "compta" : "treso"}
        offHandleColor="#FFFFFF"
        onHandleColor="#FFFFFF"
        handleDiameter={45}
        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
        height={30}
        width={70}
        className={`react-switch ${mode}`}
        checkedIcon={<></>}
        uncheckedIcon={<></>}
        checkedHandleIcon={
          <div className="switch-group checked-handle-icon">
            <img src={compta} alt="compta" />
          </div>
        }
        uncheckedHandleIcon={
          <div className="switch-group unchecked-handle-icon">
            <img src={coins} alt="treso" />
          </div>
        }
      />
    </Tooltip>
  );
}

export default SwitchMode;
